<template>
  <div>
    <v-navigation-drawer id="appDrawer" clipped fixed app v-model="drawer" width="260">
      <v-list-tile v-for="item in sideBar" :key="item.op" @click="teste(item.op)">
        <v-list-tile-action :prepend-icon="item.icon">
          <v-icon>{{ item.icon }}</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>{{ item.nome }}</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-navigation-drawer>

    <v-toolbar class="elevation-1" color="primary" dark fixed clipped-left app>
      <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
      <v-toolbar-title>Estoque</v-toolbar-title>

      <v-spacer></v-spacer>

      <v-btn icon @click="logout">
        <v-icon>power_settings_new</v-icon>
      </v-btn>
    </v-toolbar>
  </div>
</template>

<script>
export default {
  components: {},
  computed: {},
  data() {
    return {
      nameApp: "",
      mini: false,
      drawer: null,
      sideBar: [],
      primary: false,
      dialog: false,
      login: true,
      user: {},
      items: [],
      colors: {},
      action: true
    };
  },
  props: {},
  mounted() {
    this.carregarOpcoes();
    this.user = this.$store.getters.usuario;
    this.sideBar = this.$store.getters.drawer;
    this.colors = this.$store.getters.colors;
  },
  methods: {
    teste: function(data) {
      switch (data) {
        case 1:
          this.$router.push("/");
          break;
        default:
          this.$router.push("/login");
          break;
      }
    },
    logout: function() {
      this.$store.dispatch("FedLogOut").then(r => {
        this.$router.push("/login");
      });
    },
    carregarOpcoes: function() {
      this.items = [
        {
          title: "Home",
          icon: "dashboard",
          id: 1
        },
        {
          title: "Relatório",
          icon: "assignment",
          id: 2
        }
      ];
    }
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/toolbars/AppToolbar.vue